import { useState } from "react"
import { HexMap } from "../../Data/HexMap/HexMap"
import { BuildHexMap } from "../../Data/HexMap/HexMapBuilder"
import { Note } from "../../Data/HexMap/Note"
import { Music } from "../../Util/Music/Music"
import { TransformTranslate } from "../../Util/Transform/Transform"
import { HxMapGroup } from "../HxMap/HxMapGroup"
import { Modes } from "../../Util/Music/Modes"
import { Capitalize } from "../../Util/Strings/Capitalize"

export function ModalPositions(props:{width?:number, height?:number, radius?:number}){
    const visibleNotes:number[] = [0,1,2,3,4,5,6]
    const radius:number = (props.radius) ? props.radius : 130
    const width:number = (props.width) ? props.width : radius * 2.8
    const height:number = (props.height) ? props.height : radius * 2.8
    const tonic:number = Music.G
    const [offset, setOffset] = useState<number>(0)
    const [haloNotes, setHaloNotes] = useState<number[]>([])
    const onNoteClick = (note:Note, e:any) => {
        if (e.metaKey || e.ctrlKey){
            if(!haloNotes.includes(note.params.noteIndex)){
                setHaloNotes(haloNotes.concat([note.params.noteIndex]))
            }
            return
        }
        const freshOffset:number = visibleNotes.indexOf(note.params.noteIndex)
        setOffset(freshOffset)
    }
    const getMap = () => {  
        const mapData:HexMap = BuildHexMap({columns:1, rows:1, tonic:tonic, radius:radius})
        mapData.notes.forEach((note:Note, index:number)=>{
            const scaleIndex:number = visibleNotes.indexOf(index)
            const defined:boolean = (scaleIndex > -1)
            note.defined = defined
            if(defined){
                note.secondaryLabel = String(((scaleIndex - offset + 7) % 7) + 1)
                note.selectedState = (scaleIndex === offset) ? Note.SelectedState_Hilited : Note.SelectedState_Default
            }
            if (haloNotes.includes(index)){
                note.halo = true
                if(scaleIndex !== offset){note.classNames.push('selected')}
            }
        })
        return mapData
    }
    return(
        <div className={'modal-positions'}>
            <div style={{margin:4}} >Mode:{Capitalize(Modes.Names[offset])}</div>
            <svg width={width} height={height}>
                <g transform={TransformTranslate(width/2, height/2)}>
                    <HxMapGroup hexMap={getMap()} onNoteClick={onNoteClick}/>
                </g>
            </svg>
        </div>

    )
}